import content, { ContentType, currentYear, footer } from './content';

let contentKeys = Object.keys(content);
const currentContent = content[currentYear] || content[contentKeys[0]];

export default currentContent;
export { ContentType, currentYear, footer };